import useQuery from './useQuery';

/**
 * Indica que a página está sendo exibida dentro do app da Eduzz (?eduzzapp=true).
 * Nesse modo escondemos os elementos de navegação do site (header, menus, logo e rodapé).
 */
function useIsEduzzApp() {
  const query = useQuery();

  return query.get('eduzzapp') === 'true';
}

export default useIsEduzzApp;
